
import { defineComponent } from 'vue'

import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'

export default defineComponent({
    components: {
        OkButton,
    },
    emits: ['confirm', 'cancel'],
    setup(props, { emit }) {
        const onConfirm = () => {
            emit('confirm')
        }

        const onCancel = () => {
            emit('cancel')
        }

        return {
            onConfirm,
            onCancel,
        }
    },
})
